import { render, staticRenderFns } from "./cityRegion.vue?vue&type=template&id=63cd20c2&scoped=true&"
import script from "./cityRegion.vue?vue&type=script&lang=js&"
export * from "./cityRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cd20c2",
  null
  
)

export default component.exports